 import React, { useId, useRef, useEffect, useState } from "react";
 import { Helmet } from "react-helmet-async";
 import { styled } from "@mui/material/styles";
 import {
   Typography,
   Card,
   Stack,
   Box,
   TextField,
   FormGroup,
   FormControlLabel,
   Checkbox,
   Button,
   ButtonBase,
   Popover, 
 } from "@mui/material";
 import { useAuth0 } from "@auth0/auth0-react";
 import SignUpBackground from "src/public/assets/illustrations/signupBackground.png";
 import LeftSideImage from "src/public/assets/illustrations/leftSide.png";
 import RightSideImage from "src/public/assets/illustrations/rightSide.svg";
 import InputField from './InputField.js'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import LoadingAnimation from './loading.json';
 


 export default function Loading({}) {

    const auth0LoginUrl =
  "https://dev-4m53d4wv8p6pmod8.us.auth0.com/u/login";


    const handleSignIn = () => {
    window.location.href = auth0LoginUrl;
  };


    return (

 <>

       <Box
      sx={{
        display: "flex",
        flexDirection: "column",   // put the animation on top, text below
        alignItems: "center",      // horizontal centering
        justifyContent: "center",  // vertical centering (optional)
        mt:-12
      }}
    >
      {/* bubble with the animation */}
      <Box
        sx={{
          width: 300,
          height: 300,
   
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb:-8
        }}
      >
        <DotLottieReact
          src="https://lottie.host/fea555da-ac1a-4d53-ad7e-0c3b7dde27d4/Fwt4iJ2sJR.lottie"
          loop
          autoplay
          style={{ width: 300, height: 300 }} // keep the lottie inside the circle
        />
      </Box>

      {/* centred text */}
    <Typography
      sx={{
        fontFamily: "'Lato', sans-serif",
        fontWeight: 900,
        fontSize: 25,
        color: "#456579",
        letterSpacing: "-0.02em",
        textAlign: "center",

        lineHeight:'30px'
      }}
    >
      Almost there...
     
    </Typography>
    <Typography sx={{
        fontFamily: "'Lato', sans-serif",
        fontWeight: 500,  
        fontSize: 18,
        color: "#456579",
        letterSpacing: "-0.03em",
        textAlign: "center",
        pt: 2,
      
      }}
    >
Hang tight. We’re creating your account

    </Typography>

    </Box>
              </>


  );
}
